import React from "react";
import { Arrow, Text, Group } from "react-konva";

class Transition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      draggable: true,
      stroke: props.stroke,
      strokeWidth: props.strokeWidth,
      visible: true,
      text: this.props.label, //esse valor que eu uso como identificador
      radius: 30,
      location: this.props.location,
      initial: this.props.initial,
      final: this.props.final,
      xcur: this.props.initial.xPos,
      ycur: this.props.initial.yPos,
      xfut: this.props.final.xPos,
      yfut: this.props.final.yPos,

      kXcur: this.props.initial.xPos, //armazena a posiçao x do centro do estado current
      kYcur: this.props.initial.yPos, //armazena a posiçao y do centro do estado current
      kXfut: this.props.final.xPos, //armazena a posiçao x do centro do estado future
      kYfut: this.props.final.yPos, //armazena a posiçao y do centro do estado future

      xmid: (this.props.initial.xPos + this.props.final.xPos) / 2,
      ymid: (this.props.initial.yPos + this.props.final.yPos) / 2,
    };
  }
  componentDidMount() {
    this._isMounted = true;
    this.updateTransitionPosition();
  }
  componentDidUpdate(oldProps) {
    if (
      oldProps.initial !== this.props.initial ||
      oldProps.final !== this.props.final
    ) {
      this.updateTransitionPosition();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getTransitionFrom(state, childs) {
    let transitions = [];

    childs.forEach((machineElement) => {
      if (machineElement != null) {
        const typeElement = machineElement.constructor.name;
        if (typeElement === "Transition") {
          if (state.text == machineElement.state.initial.text) {
            transitions.push(machineElement);
          }
        }
      }
    });
    return transitions;
  }
  getTransitionTo(state, childs) {
    let transitions = [];
    childs.forEach((machineElement) => {
      if (machineElement != null) {
        const typeElement = machineElement.constructor.name;
        if (typeElement === "Transition") {
          if (state.text == machineElement.state.final.text) {
            transitions.push(machineElement);
          }
        }
      }
    });
    return transitions;
  }
  getTransition(initialState, futureState, childs) {
    for (let i = 0; i < childs.length; i++) {
      const machineElement = childs[i];
      if (machineElement != null) {
        const typeElement = machineElement.constructor.name;
        if (typeElement === "Transition") {
          if (
            initialState.text == machineElement.state.initial.text &&
            futureState.text == machineElement.state.final.text
          ) {
            return machineElement;
          }
        }
      }
    }
  }

  bendLeft = (xc, yc, xf, yf) => {
    if (this._isMounted) {
      this.setState({
        ymid: (yc + yf) / 2 - 20,
        xmid: (xc + xf) / 2 - 20,
      });
    }
  };

  bendRight = (xc, yc, xf, yf) => {
    if (this._isMounted) {
      this.setState({
        ymid: (yc + yf) / 2 + 20,
        xmid: (xc + xf) / 2 - 20,
      });
    }
  };

  notBend = (xc, yc, xf, yf) => {
    if (this._isMounted) {
      this.setState({
        ymid: (yc + yf) / 2,
        xmid: (xc + xf) / 2,
      });
    }
  };

  updateTransitionPosition = (isBend) => {
    if (!this._isMounted) {
      return;
    }
    try {
      if (
        this.state.xcur !== undefined &&
        this.props.initial.text !== this.props.final.text
      ) {
        const xc = this.props.initial.xPos;
        const yc = this.props.initial.yPos;
        const xf = this.props.final.xPos;
        const yf = this.props.final.yPos;

        if (xf > xc) {
          if (yf > yc) {
            this.bendRight(xc, yc, xf, yf);
          } else if (yf < yc) {
            this.bendLeft(xc, yc, xf, yf);
          } else {
            if (isBend == true) {
              this.bendLeft(xc, yc, xf, yf);
            } else if (isBend == false) {
              this.notBend(xc, yc, xf, yf);
            }
          }
        } else if (xf < xc) {
          if (yf > yc) {
            if (this._isMounted) {
              this.setState({
                ymid: (yc + yf) / 2 + 20,
                xmid: (xc + xf) / 2 + 20,
              });
            }
          } else if (yf < yc) {
            if (this._isMounted) {
              this.setState({
                ymid: (yc + yf) / 2 - 20,
                xmid: (xc + xf) / 2 + 20,
              });
            }
          } else {
            if (isBend == true) {
              this.bendRight(xc, yc, xf, yf);
            } else if (isBend == false) {
              this.notBend(xc, yc, xf, yf);
            }
          }
        } else {
          if (yf > yc) {
            if (this._isMounted) {
              this.setState({
                ymid: (yc + yf) / 2 - 20,
                xmid: (xc + xf) / 2 + 20,
              });
            }
          } else if (yf < yc) {
            if (this._isMounted) {
              this.setState({
                ymid: (yc + yf) / 2 + 20,
                xmid: (xc + xf) / 2 - 20,
              });
            }
          }
        }

        let deltaXcur = xc - this.state.xmid;
        let deltaYcur = yc - this.state.ymid;
        let deltaXfut = xf - this.state.xmid;
        let deltaYfut = yf - this.state.ymid;

        let lengthCur = Math.sqrt(
          Math.pow(deltaXcur, 2) + Math.pow(deltaYcur, 2)
        );
        let lengthFut = Math.sqrt(
          Math.pow(deltaXfut, 2) + Math.pow(deltaYfut, 2)
        );

        let fatorCur = lengthCur / this.state.radius;
        let fatorFut = lengthFut / this.state.radius;
        deltaXcur /= fatorCur;
        deltaYcur /= fatorCur;
        deltaXfut /= fatorFut;
        deltaYfut /= fatorFut;
        let difXcur = xc - deltaXcur;
        let difYcur = yc - deltaYcur;
        let difXfut = xf - deltaXfut;
        let difYfut = yf - deltaYfut;

        if (this._isMounted) {
          this.setState({
            xcur: difXcur,
            ycur: difYcur,
            xfut: difXfut,
            yfut: difYfut,
          });
          this.setState({
            kXcur: difXcur,
            kYcur: difYcur,
            kXfut: difXfut,
            kYfut: difYfut,
          });
        }
      } else {
        if (this._isMounted) {
          this.setState({
            kXcur: this.props.initial.xPos,
            kYcur: this.props.initial.yPos,
            kXfut: this.props.final.xPos,
            kYfut: this.props.final.yPos,
          });
          this.setState({
            xmid: this.props.initial.xPos,
            ymid: this.props.initial.yPos - this.state.radius - 70,
          });
        }
      }
    } catch (e) {
      alert("err", e);
    }
  };

  dragEndText = (e) => {
    if (this._isMounted) {
      const pos = {
        x: e.evt.layerX,
        y: e.evt.layerY,
      };
      this.setState({
        xmid: pos.x,
        ymid: pos.y,
      });
    }
  };

  changeCursor = (e, type) => {
    const container = e.target.getStage().container();
    container.style.cursor = type;
  };

  render() {
    let arrayPointsRenderTransition;
    if (
      this.state.initial &&
      this.props.initial.text === this.props.final.text
    ) {
      arrayPointsRenderTransition = [
        this.props.initial.xPos - 5,
        this.props.initial.yPos - this.state.radius,
        this.props.initial.xPos - 20,
        this.props.initial.yPos - this.state.radius - 30,
        this.props.initial.xPos,
        this.props.initial.yPos - this.state.radius - 50,
        this.props.initial.xPos + 20,
        this.props.initial.yPos - this.state.radius - 30,
        this.props.final.xPos + 5,
        this.props.final.yPos - this.state.radius,
      ];
    } else {
      arrayPointsRenderTransition = [
        this.state.kXcur,
        this.state.kYcur,
        this.state.xmid,
        this.state.ymid,
        this.state.kXfut,
        this.state.kYfut,
      ];
    }
    return (
      <Group>
        {this.state.visible && (
          <Group>
            <Arrow
              points={arrayPointsRenderTransition}
              stroke={this.props.stroke}
              strokeWidth={this.props.strokeWidth}
              tension={0.54}
              fill={"#e9eaea"}
            />

            <Text
              height={75}
              width={75}
              align="center"
              verticalAlign="middle"
              ref={this.myRef}
              x={this.state.xmid - 35.7}
              y={this.state.ymid - 30}
              text={this.props.label}
              fontSize={15}
              draggable={true}
              onDragEnd={this.dragEndText}
              onClick={(e) => {
                this.props.onClick(e, this);
              }}
              onTap={(e) => {
                this.props.onTap(e, this);
              }}
              onMouseEnter={(e) => {
                this.changeCursor(e, "pointer");
              }}
              onMouseLeave={(e) => {
                this.changeCursor(e, "");
              }}
              fill={this.props.labelColor}
            />
          </Group>
        )}
      </Group>
    );
  }
}
export default Transition;
